import { InjectionToken, WritableSignal } from '@angular/core';

export const AIDA_WARNING_LIMIT: InjectionToken<WritableSignal<int>> = new InjectionToken('AIDA_WARNING_LIMIT');
